export interface PdfCanvasProps {
  url: string;
  className?: string;
}

export enum PdfCanvasStatus {
  LOADING = 'loading',
  READY = 'ready',
  ERROR = 'error',
}

export const PDF_CANVAS_MAX_PIXEL_RATIO = 2;
